import React, {useRef} from "react";
import HubspotForm from 'react-hubspot-form';
import {useI18next, useTranslation} from 'gatsby-plugin-react-i18next';

export const SubscribeForm = ({portalId, formId}) => {
  const hubspotFormRef = useRef(null);
  const {t} = useTranslation();
  const {language} = useI18next();

  if (!portalId || !formId) return null;

  return (
    <HubspotForm
      locale={language}
      ref={hubspotFormRef}
      portalId={portalId}
      formId={formId}
      cssClass="tw-subscribe-form tw-form"
      submitButtonClass="tw:btn-filled"
      loading={<div>{t("Loading...")}</div>}
    />
  )
}
